import type { TaskComment } from '../../types';
import type { CommentResponseDto } from '@/types/api';

/**
 * Maps a comment API response to a frontend TaskComment.
 */
export function mapCommentFromApi(comment: CommentResponseDto): TaskComment {
  return {
    id: comment.id,
    message: comment.message,
    author: comment.authorName,
    authorId: comment.authorId,
    authorAvatarUrl: comment.authorAvatarUrl,
    createdAt: new Date(comment.createdAt),
    updatedAt: comment.updatedAt ? new Date(comment.updatedAt) : undefined,
    isDeleted: comment.isDeleted,
  };
}
